// extracted by mini-css-extract-plugin
module.exports = {"header":"subheader__header___2KOvW"};